import $ from 'jquery';
import crud from './helpers/crud';
import { paramify } from '../Etc';
import join from 'url-join';
import { servletGetResults, getError } from './helpers';
import JSOG from 'jsog';

export default class RecruitDAO extends crud {
  constructor(urls) {
    super(urls.RECRUITS_URL);
    this.RECRUITS_URL = urls.RECRUITS_URL;
    this.RECRUITS_MERGE_URL = urls.RECRUITS_MERGE_URL;
    this.RECRUITS_YEARS_URL = urls.RECRUITS_YEARS_URL;
  }

  /**
   * Add the tourney ID to each recruit in the list
   */
  addTourney(recruits, tourneyId) {
    const promises = [];
    if (tourneyId) {
      _.each(recruits, (recruit) => {
        if (recruit.id) {
          promises.push(this.addRecruitToTourney(recruit.id, tourneyId));
        }
      });
    }

    return Promise.all(promises);
  }

  /**
   * Add tourney to a recruit
   * @param recruitId id of recruit to add tourney to
   * @param tourneyId tourney id to add to recruit
   * @returns {*}
   */
  addRecruitToTourney(recruitId, tourneyId) {
    return new Promise((resolve, reject) => {
      if (!recruitId || !tourneyId) {
        reject(new Error('recruit ID and tourney ID are required'));
      } else {
        // get the recruit
        this.getSingle(recruitId)
          .then((recruit) => {
            const recruitTourneys = recruit.recruitTourneys;
            const tourneys = _.pluck(recruitTourneys, 'tourney');
            const tourneyIds = _.pluck(tourneys, 'id');

            if (_.contains(tourneyIds, tourneyId)) {
              // already on the tourney
              resolve();
            } else {
              // create a new recruit to PUT
              const newRecruit = Object.assign({}, recruit, {
                // construct a new recruit tourneys object
                recruitTourneys: recruitTourneys.concat([
                  {
                    tourney: { id: tourneyId }
                  }
                ])
              });

              $.ajax({
                method: 'PUT',
                url: join(this.RECRUITS_URL, recruit.id),
                contentType: 'application/json',
                data: JSOG.stringify(newRecruit)
              })
                .then((savedRecruit) => {
                  resolve();
                }, (jqXhr) => {
                  reject(getError(jqXhr));
                });
            }
          });
      }
    });
  }

  /**
   * Get an array of years representing all the classes of which account recruits are a part
   * @param refresh whether to break cache
   * returns {Promise}
   */
  getYears(refresh) {
    return servletGetResults(this.RECRUITS_YEARS_URL, refresh);
  }

  /**
   * Merge recruits
   * @param preview boolean true if merge should only be preview mode
   * @param accountId required account ID of the merge
   * @param recruitIds optional specific list of recruit IDs to merge, otherwise
   * @param filters optionally merge recruits that match the query parameter filters
   * @returns promise that resolves to merged recruits result
   */
  merge({ preview, accountId, recruitIds, filters = {} }) {
    return new Promise((resolve, reject) => {
      const qp = paramify(filters);
      $.ajax({
        method: 'POST',
        contentType: 'application/json',
        url: `${this.RECRUITS_MERGE_URL}?${qp}`,
        data: JSON.stringify({ preview, accountId, recruitIds })
      }).then((recruitMergeData) => {
        resolve(JSOG.decode(recruitMergeData));
      }, (jqXhr) => {
        reject(getError(jqXhr, 'Failed to merge recruits.'));
      });
    });
  }


  /**
   * Remove a recruit ID from a tourney ID
   * @param recruitId ID of the recruit to remove
   * @param tourneyId ID of the tourney to remove from
   * @returns {*}
   */
  removeTourney(recruitId, tourneyId) {
    return new Promise((resolve, reject) => {
      if (!recruitId || !tourneyId) {
        reject(new Error('recruitId and tourneyId are required'));
      } else {
        this.getSingle(recruitId).then(recruit => {
          const { recruitTourneys } = recruit;
          const tourneys = _.pluck(recruitTourneys, 'tourney');
          const tourneyIds = _.pluck(tourneys, 'id');

          if (!_.contains(tourneyIds, tourneyId)) {
            resolve();
          } else {
            const newRecruit = { ...recruit,
              recruitTourneys: _.filter(recruitTourneys, rt => rt.tourney.id !== tourneyId)
            };
            return this.save(newRecruit);
          }
        }, reject);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/util/dao/RecruitDAO.js